import './style.scss';

function Settings(props) {
  return (
    <div className="Datasources">
      {props.children}
    </div>
  );
}

export default Settings;
